import React, { useState, useEffect } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Processer from "../components/items/processer";
import ButtonLoader from "../components/items/buttonLoader";
import { mainURL } from "../assets/constants/api";
import "../assets/css/step.css";
const LoginTest = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [sendingCode, setSendingCode] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [validCode, setValidCode] = useState(false);
  const [changeIconAfterEmailCheck, setChangeIconAfterEmailCheck] = useState(false);
  const [changeIconAfterCodeCheck, setChangeIconAfterCodeCheck] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [failedSendingCode, setFailedSendingCode] = useState("");

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("بريد إلكتروني غير صالح")
      .required("يرجى إدخال بريدك الإلكتروني")
      .max(100, "يجب ألا يتجاوز 100 محرف")
      .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i, "البريد الإلكتروني غير صالح"),
    verification_code: Yup.string(),
  });

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const sendVerificationCode = async (email) => {
    setSendingCode(true);
    setFailedSendingCode("");
    setValidEmail(false);
    setChangeIconAfterEmailCheck(true);
    try {
      const res = await axios.post(`${mainURL}/web/auth/send-verification-email`, { email });

      if (res.data.success) {
        

        setCodeSent(true);
        setValidEmail(true);
        setStep(1);
        setResendTimer(30);
      } else {
        setFailedSendingCode("فشل إرسال الرمز");
      }
    } catch (error) {
      setFailedSendingCode("حدث خطأ أثناء إرسال الرمز");
    } finally {
      setSendingCode(false);
    }
  };

  const verifyCode = async (formData, setFieldError) => {
    if (!formData.verification_code) return;

    setVerifying(true);
    setChangeIconAfterCodeCheck(true);
    setValidCode(false);

    try {
      const res = await axios.post(`${mainURL}/web/auth/verify-email`, formData);
      if (res.data.success) {
        const { auth_token, user } = res.data.data;
        Cookies.set("auth_token", auth_token, { secure: false, sameSite: "Lax", expires: 7 });
        Cookies.set("user_data", JSON.stringify(user), { secure: true, sameSite: "Strict", expires: 7 });
        setValidCode(true);
        setTimeout(() => navigate("/"), 1000);
      } else {
        setFieldError("verification_code", "الرمز الذي أدخلته غير صحيح");
      }
    } catch (error) {
      setFieldError("verification_code", "حدث خطأ أثناء التحقق");
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="login-section padding-tb">
      <div className="container">
        <div className="account-wrapper">
          <Formik
            initialValues={{ email: "", verification_code: "" }}
            validationSchema={validationSchema}
            onSubmit={() => {}}
          >
            {({ values, setFieldError, errors }) => (
              <AnimatePresence mode="wait">
                {step === 0 ? (
                  <motion.div
                    key="email-step"
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -30 }}
                    transition={{ duration: 0.4 }}
                    className="row setup-content active"
                  >
                    <div className="form-group">
                      <label>البريد الإلكتروني:</label>
                      <div className="d-flex align-items-center">
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="example@gmail.com"
                          onFocus={() => setChangeIconAfterEmailCheck(false)}
                        />
                        <button
                          type="button"
                          className="flex-grow-1 toggle-password"
                          onClick={() => sendVerificationCode(values.email)}
                          disabled={!!errors.email || sendingCode}
                        >
                          {sendingCode ? (
                            <ButtonLoader fontSize="1.5rem" />
                          ) : (
                            <i
                              className={`${
                                !changeIconAfterEmailCheck
                                  ? "icofont-arrow-left"
                                  : validEmail
                                  ? "icofont-check text-success"
                                  : "icofont-close text-danger"
                              }`}
                            ></i>
                          )}
                        </button>
                      </div>
                      <ErrorMessage name="email" component="div" className="text-danger mt-1" />
                    </div>
                  </motion.div>
                ) : (
                  <motion.div
                    key="code-step"
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -30 }}
                    transition={{ duration: 0.4 }}
                    className="row setup-content active"
                  >
                    {failedSendingCode && (
                      <div className="alert alert-danger">{failedSendingCode}</div>
                    )}

                    {sendingCode && (
                      <Processer processingText="جارِ إرسال رمز التحقق..." />
                    )}

                    {codeSent && (
                      <>
                        <p className="alert alert-success mt-3 row d-flex">
                          تم إرسال الرمز بنجاح. تحقق من بريدك الإلكتروني وأدخل الرمز أدناه.
                        </p>

                        <div className="form-group">
                          <label>رمز التحقق:</label>
                          <div className="d-flex align-items-center">
                            <Field
                              name="verification_code"
                              type="text"
                              className="form-control"
                              placeholder="أدخل رمز التحقق"
                              onFocus={() => setChangeIconAfterCodeCheck(false)}
                            />
                            <button
                              className="flex-grow-1 toggle-password"
                              type="button"
                              onClick={() => verifyCode(values, setFieldError)}
                            >
                              {verifying ? (
                                <ButtonLoader fontSize="1.5rem" />
                              ) : (
                                <i
                                  className={`${
                                    !changeIconAfterCodeCheck
                                      ? "icofont-arrow-left"
                                      : validCode
                                      ? "icofont-check text-success"
                                      : "icofont-close text-danger"
                                  }`}
                                ></i>
                              )}
                            </button>
                          </div>
                          <ErrorMessage
                            name="verification_code"
                            component="div"
                            className="text-danger mt-1"
                          />
                        </div>

                        {resendTimer > 0 ? (
                          <div className="text-muted mt-2">
                            يمكنك إعادة الإرسال خلال {resendTimer} ثانية
                          </div>
                        ) : (
                          <button
                            className="btn btn-link mt-3"
                            onClick={() => sendVerificationCode(values.email)}
                            disabled={sendingCode}
                          >
                            إعادة إرسال الرمز
                          </button>
                        )}

                        <button
                          className="btn btn-secondary mt-3"
                          onClick={() => setStep(0)}
                        >
                          العودة لتعديل البريد
                        </button>
                      </>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            )}
          </Formik>
          <div className="account-bottom">
                        <span className="or">
                          <span>أو</span>
                        </span>
          
                        <span className="d-block cate pt-10">
                          ليس ليك حساب ؟
                          <Link to="/signup" className="text-warning pointer">
                            أنشئ حساب
                          </Link>
                        </span>
                      </div>
        </div>
      </div>
    </div>
  );
};

export default LoginTest;
